import { mapDTO } from '@twistezo/ts-dto-mapper'

import type { WorkspaceGeneralConfigurationFragmentFragment } from 'gql/graphql'

type From = WorkspaceGeneralConfigurationFragmentFragment
type To = WorkspaceGeneralConfigurationFragmentFragment

export const fromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform(
    ({ id, newDomainsDefaultBranch }: From): To => ({
      id,
      newDomainsDefaultBranch,
    }),
  )
